module.exports = __webpack_public_path__ + "assets/img/yyindex-10.71b699ef.png";